import {withStyles} from "@material-ui/styles";
import Tooltip from "@material-ui/core/Tooltip";

export const CustomTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: 'rgba(0, 0, 0, 0.9)',
        fontSize: theme.typography.pxToRem(14),
        top: "8px",
    },
    arrow: {
        color: 'rgba(0, 0, 0, 0.9)',
    },
}))(Tooltip);